import React, { useEffect } from 'react';
import MyGuestsAdd from './MyGuestsAdd';
import { useHistory } from 'react-router-dom';
import felcha_izquierda from 'assets/img/felcha_izquierda.svg';
import { useWindowSize } from 'hooks';
function MyGuestAddLanding({
  tableInfo,
}) {
  const [, { isMobile }] = useWindowSize();
  const history = useHistory();

  const handleRegresarClick = () => {
    history.push('/rsvp');
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Esto hace que la página se desplace al principio
  }, [])

  return (
    <>
      {!isMobile && (<span className="float-left" onClick={handleRegresarClick}><i class="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span> )}
      <br />
      <div>
        <h1>Agrega tus invitados</h1>
        <h5>Ingresa los datos de tus invitados</h5>
        <br /><br />
        <MyGuestsAdd typeId={tableInfo?.evento} />
        <br />
      </div>
    </>
  );
}

export default MyGuestAddLanding;
